export function buildExamModeRequest() {
  return {
    mode: 'EXAM',
    limit: 40,
    excludeAnswered: 'true'
  }
}
